<template>
  <div class="hello">
    <Navbar></Navbar>
    <h4 class="card-title" style="padding-top:30px;padding-bottom:30px;background-color:#c3c3c338;">
      <b>Frequently Asked Questions about Snakes   : Biology and ecology of snakes  
</b>
    </h4>
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <p style="text-align:justify;font-size:18px;">
           Snakes are fascinating animals that have been feared and revered by mankind as far back as recorded history goes. Every civilization across the world has symbols of snakes as part of its culture, religion or rituals. There are thousands of myths and questions about snakes asked by people all over the world and we are attempting to answer a few of them here. Our team has been asked these questions directly by people that we met through the years. Some of the questions are scientific and the others are clarifications about myths and beliefs. We hope you find your answers here;  if not, please feel free to write to <a
              href="mailto:jose@indiansnakes.org"
            >jose@indiansnakes.org</a> 

            
          </p>
        </div>

        <div class="col-md-12" style="margin-bottom:180px;">
          <br />
          <div class="card">
            <div class="card-body" style="text-align:left;font-size:18px;">
              <div class="row">
                  <div class="col-md-6">
           <p>&#9642; <a href="/snakesbiology">Snakes Biology & Ecology</a></p>
        <p>&#9642; Myths related snakes </p>
        <p>&#9642; Snakes and culture </p>
                  </div>
                  <div class="col-md-6">
                       <p>&#9642; <a href="/venomfaq">Snakebites & Snake venom</a></p>
        <p>&#9642; Snakebite treatment </p>
        <p>&#9642; <a href="/legalissuesfaq">Legal issues & Best practices</a></p>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from "./navbar";
export default {
  name: "HelloWorld",
  props: {
    msg: String
  },
  components: {
    Navbar
  }
};
</script>
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>